var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 d-flex justify-content-center"},[_c('img',{staticStyle:{"height":"64px"},attrs:{"src":_vm.loadingImg,"alt":"Preloading image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }